import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaWith } from 'theme'
import Carousel from 'components/Carousel'
import ProgressLines from 'components/Carousel/ProgressLines'
import WalletCarouselSlide from '../WalletCarouselSlide'
import { CarouselSection, CarouselWrapper } from './styles'

const slides = Array.from({ length: 9 }).map(
  (_, index) => require(`assets/images/wallet/carousel/slide${index + 1}.png`).default
)

export default function WalletCarousel({ data }) {
  const { upToMedium } = useMediaWith()

  const slidesData = data.map((slide) => {
    const slideData = slide.attributes
    return {
      title: slideData.Title,
      description: slideData.Description,
      type: slideData.Category,
    }
  })

  const slideImages = data.map((step) => {
    const data = step?.attributes?.Image?.data
    const url = data?.attributes.url
    return `https://cms.lif3.com${url}`
  })

  const slidesPerView = upToMedium ? 1 : 3
  const spaceBetween = upToMedium ? 10 : 30

  return (
    <CarouselSection>
      <CarouselWrapper>
        <Carousel
          slidesData={slidesData}
          slidesImages={slideImages}
          slidesPerView={slidesPerView}
          spaceBetween={spaceBetween}
          ProgressComponent={ProgressLines}
          mobileButtons={false}
          SlideComponent={WalletCarouselSlide}
          autoScroll={true}
        ></Carousel>
      </CarouselWrapper>
    </CarouselSection>
  )
}
